import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackCta } from "@/lib/analytics";

/**
 * GTM's page-load trigger fires once in an SPA. Push an explicit event on
 * every route change so GA4 can count real pageviews.
 */
export const AnalyticsRouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Let the route's own title/SEO hook run first.
    const id = window.setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  // Outbound clicks to the Argus app / Chrome Web Store are this site's
  // sign-in signal — the sign-in itself happens off-site.
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement | null)?.closest?.("a") as HTMLAnchorElement | null;
      const href = anchor?.href;
      if (!href) return;
      if (href.includes("trustargus.ai")) {
        trackCta("sign_in_click", window.location.pathname, { cta: "argus_app", link_url: href });
      } else if (href.includes("chromewebstore.google.com")) {
        trackCta("sign_in_click", window.location.pathname, { cta: "get_argus_chrome", link_url: href });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
};